import React,{ useRef, useState, useEffect } from 'react';
import clsx from 'clsx';
import styles from '../../../styles/referral/global.module.css';
import '../../../styles/global.css';
import logo from '../../../assets/images/verticaltv/logo-trail-web01.png';
import styleLogin from './login.module.css';
import { useTranslation } from 'react-i18next';
import Input from '../../../components/Input';
import { Link, NavLink } from 'react-router-dom';
import { API_ROUTES, NAVIGATION_ROUTES, SIGN_UP_ACTION, DEFAULT_NUMBER_VALIDATION } from '../../../constant';
import { isExternalUrl, handleLinkClick } from '../../../utils/externalLinkHandler';
import useExtraFunctions from '../../../hooks/useExtraFunctions';
import useLoginStore from '../../../storage/store/useLoginStore';
import Toast from '../../../components/Toast/toast';
import { Bounce, Id, toast } from 'react-toastify';
import useSendOtp from '../../../api/otp';
import { useCallback } from 'react';
import { debounce } from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTokenStore } from '../../../storage/tokenState';
import { getCommonApiWithoutToken } from '../../../api/commonApi';
// import usePreSignUpAPI from '../../../api/preSignUp';
import Loader from '../../../components/Loader';
import { CLEVERTAP_EVENTS } from '../../../analytics/trackerEvents/cleverTap/events';
import { CT_PARAMS } from '../../../analytics/trackerEvents/cleverTap/parameters';
import { trackCleverTapEvent } from '../../../utils/cleverTapHelper';




const LoginPage: React.FC = () => {

    const { t } = useTranslation();
    const mobileNumberRef = useRef<HTMLInputElement>(null);
    const [mobileNumber, setMobileNumber] = useState('');
    const [focusCheck, setFocusCheck] = useState(false);
    const [isDeclarationChecked, setIsDeclarationChecked] = useState(true);
    const toastId = useRef<Id>();
    const eventTrackedRef = useRef(false);
    const { requestOtp } = useSendOtp();

    const { validateMobile } = useExtraFunctions();
    const [errorShow, setErrorShow] = useState(true);
    const { mobileNumberState, setMobileNumberState } = useLoginStore();
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const { token, logout } = useTokenStore();
    // const { getdataPreSignup } = usePreSignUpAPI();

    const [loading, setLoading] = useState(false);

   // Populate mobile number from store when component mounts (e.g., when navigating back from OTP screen)
   useEffect(() => {
       if (mobileNumberState) {
           setMobileNumber(mobileNumberState);
           setFocusCheck(true);
       }
   }, [mobileNumberState]);

   // Track screen view event only once when component mounts
   // Sign-ups flow (/sign-ups -> /sign-ups/signup) fires WEB_EVENT_NEW_SIGN_UP_VIEW
   useEffect(() => {
    // Prevent duplicate event firing (handles React.StrictMode double-mounting)
    if (eventTrackedRef.current) {
      return;
    }
    eventTrackedRef.current = true;
    trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_NEW_SIGN_UP_VIEW, {
      [CT_PARAMS.MOBILE_NUMBER]: mobileNumber
    });
   }, []); // Empty dependency array - fires only once on mount

   // Separate useEffect for mobile number validation (runs when mobileNumber changes)
   useEffect(() => {
       const validTime = setTimeout(() => {
        if(mobileNumber.length === 10){
                if( !validateMobile(mobileNumber)){
                    setErrorShow(true);
                    toastId.current = toast.error("Invalid mobile number",{
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                        transition: Bounce,
                        style: {
                            borderRadius: '10px',
                            marginBottom: '20px',
                        }
                    });
                }else{
                    setErrorShow(false);
                }
        }
       }, 100);

       return () => {
        clearTimeout(validTime);
        if(toastId.current){
            toast.dismiss(toastId.current);
        }
       };
   
   }, [mobileNumber, validateMobile]);
   


   const handleSendOtp = useCallback(debounce(async () => {
     
    
    toastId.current && toast.dismiss(toastId.current);
    
    try {
        const response = await requestOtp(mobileNumber, 'en', SIGN_UP_ACTION , false);
        //console.log("response signup", response);
        toast.dismiss(toastId.current);

     
        navigate(
            `${NAVIGATION_ROUTES.REFERRAL_OTP}/${mobileNumber}/${SIGN_UP_ACTION}`, {state}
          );
    } catch (error) {
        console.log("error sign up", error);
        toast.error("OTP send failed",{
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
            style: {
                borderRadius: '10px',
                marginBottom: '20px',
            }
        });
    }
    //await handleSendOtp();
   }, 200), [mobileNumber, navigate]);

    const handelSubmitLogin = useCallback(async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        // Commented out preSignup API call - using default validation regex instead
        // const data = await getdataPreSignup();
        // const regex = new RegExp(data?.numberValidationRegex);
        
        // Use default validation regex from constants
        const regex = new RegExp(DEFAULT_NUMBER_VALIDATION);
        const tempNumber = `+91${mobileNumber}`; 

        if(!regex.test(tempNumber)){
            setErrorShow(true);
            mobileNumberRef.current?.focus();
          //  console.log("invalid mobile number", focusCheck);
            setTimeout(() => {
            toast.error("Invalid mobile number",{
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
                style: {
                    borderRadius: '10px',
                    marginBottom: '20px',
                }
            });
            }, 400);
            setLoading(false);
            return false;
        }
        setErrorShow(false);
        setMobileNumberState(mobileNumber);
        
        // Track CleverTap event when user proceeds with phone number
        trackCleverTapEvent(CLEVERTAP_EVENTS.WEB_EVENT_PHONE_PROCEED, {
            [CT_PARAMS.MOBILE_NUMBER]: mobileNumber
        });
        
        handleSendOtp();
        //setLoading(false);

    }, [mobileNumber, handleSendOtp]);



    const handelChangeInputMobileNumber = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setMobileNumber(e.target.value);
         
        if (!isDeclarationChecked) {
            toast.error(t("acceptTermsError"));
            setErrorShow(true);
          }else if((e.target.value).length !== 10){
            setErrorShow(true);
          }else if(!validateMobile(mobileNumber)){
            setErrorShow(true);
          }else{
            setErrorShow(false);
          }

    }, []);

    const handleCheckboxChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
          const isChecked = e.target.checked;
          setIsDeclarationChecked(isChecked);
           
    
          if (!isChecked) {
            toast.error(t("acceptTermsError"));
            setErrorShow(true);
          }else{
            setErrorShow(false);
          }
        },
        []
      );

if(loading){
    //return  <Loader />
}

  return (
    <>
        <div className={clsx(styles.gredintbox1, styles.container, styleLogin.heighFull)}>
            <div className={styleLogin.backgroundGlow}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="360" 
                    height="684" 
                    viewBox="0 0 360 684" 
                    fill="none"
                    className={styleLogin.backgroundSvg}
                >
                    <g filter="url(#filter0_fn_527_9064)">
                        <circle cx="180" cy="92" r="158" fill="#4F5568"/>
                    </g>
                    <defs>
                        <filter 
                            id="filter0_fn_527_9064" 
                            x="-412" 
                            y="-500" 
                            width="1184" 
                            height="1184" 
                            filterUnits="userSpaceOnUse" 
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                            <feGaussianBlur stdDeviation="217" result="effect1_foregroundBlur_527_9064"/>
                            <feTurbulence 
                                type="fractalNoise" 
                                baseFrequency="0.5 0.5" 
                                stitchTiles="stitch" 
                                numOctaves="3" 
                                result="noise" 
                                seed="2135"
                            />
                            <feComponentTransfer in="noise" result="coloredNoise1">
                                <feFuncR type="linear" slope="2" intercept="-0.5"/>
                                <feFuncG type="linear" slope="2" intercept="-0.5"/>
                                <feFuncB type="linear" slope="2" intercept="-0.5"/>
                                <feFuncA 
                                    type="discrete" 
                                    tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
                                />
                            </feComponentTransfer>
                            <feComposite 
                                operator="in" 
                                in2="effect1_foregroundBlur_527_9064" 
                                in="coloredNoise1" 
                                result="noise1Clipped"
                            />
                            <feComponentTransfer in="noise1Clipped" result="color1">
                                <feFuncA type="table" tableValues="0 0.4"/>
                            </feComponentTransfer>
                            <feMerge result="effect2_noise_527_9064">
                                <feMergeNode in="effect1_foregroundBlur_527_9064"/>
                                <feMergeNode in="color1"/>
                            </feMerge>
                        </filter>
                    </defs>
                </svg>
            </div>
            <div className={clsx(styles.logo, 'gptblr20')}>
                <img src={logo} alt="logo" className={clsx(styleLogin.logo)}/>
            </div>

            <div className={clsx(styleLogin.loginBox, 'flex', 'gap20','gptblr20')}>
                  <div className={clsx(styleLogin.loginBoxLeft, 'mb20')}>
                     <div className={clsx(styleLogin.loginBoxLeftTitle, 'fontSize32', 'fontWeightBold')}>
                        {t('signUp')}
                        <p className={clsx(styleLogin.loginBoxLeftTitleSub, 'fontSizeXs', 'fontWeightMedium')}>
                            {t('signUpSubTitle')}
                        </p>
                     </div>
                  </div>

                  <div className={clsx(styleLogin.loginBoxRight)}>
                    {focusCheck && <Toast/>}
                    <form onSubmit={handelSubmitLogin}>
                       <Input required ref={mobileNumberRef} stillclass={clsx(styleLogin.blackbox, 'mb20')} errorBox={focusCheck && errorShow} height={40} type="tel" divClassName={clsx(styleLogin.blackbox)} maxLength="10" placeholder={t('mobileNumber')} value={mobileNumber} onChange={handelChangeInputMobileNumber} name="number" className={clsx(styleLogin.input ,'fontSizeSm', 'fontWeightMedium')} onKeyUp={() => setFocusCheck(true)} />
                       <Input type="submit" placeholder={t('signUpSubmit')} value={t('signUpSubmit')} name="submit" className={clsx(styleLogin.submitButton, 'fontSizeSm14', 'fontWeightBold', errorShow || !isDeclarationChecked ? '' : styleLogin.enabledcolor)} disabled={((!focusCheck || errorShow) || !isDeclarationChecked)} />
                    </form>
                       <div className={clsx(styleLogin.loginBoxBottom)}>
                        {/*<div className={clsx(styleLogin.loginBoxBottomText, 'fontSizeSm14', 'fontWeightRegular', 'flex', 'alignItemCenter', 'justifyContentCenter','gptblr10')}>
                            {t('dontHaveAccount')} &nbsp; <Link to={NAVIGATION_ROUTES.REFERRAL_SIGNUP} className={clsx(styleLogin.loginBottomTextLink)}>{t('signUpBottomTextLink')}</Link>
                        </div>*/}
                       </div>
                    
                  </div>

                    <div className={clsx(styleLogin.declarationBlock)}>
                    <label
                        className={clsx(
                            styleLogin.declarationLabel,
                        "fontSizeXs fontWeightRegular"
                        )}
                    >
                        {/* <input
                        className={clsx(styleLogin.declarationCheckbox)}
                        type="checkbox"
                        checked={isDeclarationChecked}
                        onChange={handleCheckboxChange}
                        /> */}
                        {t("iAcceptThe")}
                        {isExternalUrl(NAVIGATION_ROUTES.REFERRAL_TNC) ? (
                          <a
                            href={NAVIGATION_ROUTES.REFERRAL_TNC}
                            onClick={(e) => handleLinkClick(NAVIGATION_ROUTES.REFERRAL_TNC, e)}
                            className={clsx(styleLogin.linkText, "fontWeightBold",'fontSizeSm12')}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t("t&cLabel")}
                          </a>
                        ) : (
                          <NavLink
                            to={NAVIGATION_ROUTES.REFERRAL_TNC}
                            state={{ url: NAVIGATION_ROUTES.REFERRAL_TNC }}
                            className={clsx(styleLogin.linkText, "fontWeightBold",'fontSizeSm12')}
                          >
                            {t("t&cLabel")}
                          </NavLink>
                        )}
                    </label>
                    </div>

            </div>
            
        </div>
    </>
  )
}

export default LoginPage;